module.exports = __webpack_public_path__ + "@/assets/img/seleccionamensaje.46c551d9.svg";